import I18n from 'i18n/index.js.erb'
I18n.locale = gon.locale;
I18n.defaultLocale = gon.default_locale;
window.I18n = I18n;
